import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/custom-apps/")({
  staticData: {
    title: "home.customApps",
  },
});
